import { useNavigate } from "react-router-dom";
import { Flex, Image, Text } from "@chakra-ui/react";
import {  AiOutlineHome, AiOutlineUser } from "react-icons/ai";
import { MdContactSupport } from "react-icons/md";
import { GrDocumentText } from "react-icons/gr";
import { MdOutlineAssignmentInd } from "react-icons/md";
 
import beneficiosIcon from "assets/svg/beneficios.svg";
 


export const SubHeaderAnonimous = ({mobile}) => {

    const navigate = useNavigate();  
    return (
        <Flex className="container-menu">
            <Flex className="menu">
                <Flex className="menu-item"
                    onClick={() => {
                        navigate("/");
                    }}>
                    <AiOutlineHome fontSize={mobile ? 20 : 42} />
                    <Text className="menu-text">
                        Home
                    </Text>
                </Flex>

                <Flex className="menu-item"
                    onClick={() => {
                        navigate("/cadastro");
                    }}>
                    <MdOutlineAssignmentInd fontSize={mobile ? 20 : 42} />
                    <Text className="menu-text">
                        Cadastro
                    </Text>
                </Flex>

                {!mobile &&
                <Flex className="menu-item"
                    onClick={() => navigate("/contato")}>
                    <MdContactSupport fontSize={mobile ? 20 : 42} />
                    <Text className="menu-text">
                        Contato
                    </Text>
                </Flex> }

                {!mobile && 
                <Flex className="menu-item"
                    onClick={() => {
                        navigate("/regulamento");
                    }}>
                    <GrDocumentText fontSize={mobile ? 20 : 42} />
                    <Text className="menu-text">
                        Regulamento
                    </Text>
                </Flex> }

                { /* <Flex className="menu-item"
                    onClick={() => {
                        navigate("/resgate-pix");
                    }}>
                    <Image className="menu-image" src={resgateIcon} />
                    <Text className="menu-text">
                        Resgate
                    </Text>
                </Flex> */ }

                  <Flex className="menu-item"
                    onClick={() => {
                        navigate("/login");
                    }}>
                    <AiOutlineUser fontSize={mobile ? 20 : 42} />
                    <Text className="menu-text">
                        Login
                    </Text>
                </Flex>
            </Flex>
        </Flex>
    );
};
